// @flow
import * as React from 'react'
import { SocialButtons } from '../../../shared/buttons'
import { useRouter } from 'next/router'
import { isWebView } from '../../../../actions/loadActions'

export const GOOGLE_TEXT = Object.freeze({
  signIn: 'Sign in',
  continue: 'Continue'
})
export type GoogleTextType = $Values<typeof GOOGLE_TEXT>

export type PropsType = {
  type: GoogleTextType,
  disable: boolean,
  isOutlineStyle: boolean,
  socialAuthAgeCheck: (callback: (params?: any) => Promise<void>) => void,
  isSignUp: boolean
}
export type DispatchPropsType = {
  signInWithGoogle: () => void
}

export default function GoogleSignIn (props: PropsType & DispatchPropsType): React.Node {
  const router = useRouter()
  const [isWebViewValue, setIsWebViewValue] = React.useState(false)
  React.useEffect((): void => {
    setIsWebViewValue(isWebView())
  }, [])
  if (isWebViewValue) {
    return null
  }
  return (
    <SocialButtons
      onClick={(): void => {
        props.socialAuthAgeCheck(async (): Promise<void> => {
          await router.push({
            query: {
              ...router.query,
              socialAuth: 1,
              method: props.isSignUp ? 'signup' : 'signin'
            }
          })
          props.signInWithGoogle()
        })
      }}
      disable={props.disable}
      isOutlineStyle={props.isOutlineStyle}
    >
      <img
        width={17}
        height={17}
        style={{ marginRight: '8px' }}
        alt="Sign in with Google"
        src={'/images/google-icon-3x.png'}
      />
      {props.type} with Google
    </SocialButtons>
  )
}
